export default {
  state: {
    globalConfig: []
  },
  mutations: {
    GETCONFIG(state,globalConfig) {
      state.globalConfig = JSON.parse(JSON.stringify(globalConfig))
    }
  },
  actions: {
    getConfig({commit},globalConfig) {
      commit('GETCONFIG',globalConfig)
    }
  },
  getters: {
    //获取地址
    getAddress(state){
      return state.globalConfig.find(item => item.code === 'ADDRESS') || {}
    },
    //获取邮箱
    getEmail(state){
      return state.globalConfig.find(item => item.code === 'EMAIL') || {}
    },
    //获取电话
    getPhone(state){
      return state.globalConfig.find(item => item.code === 'phone') || {}
    },
    //获取邮编
    getYB(state){
      return state.globalConfig.find(item => item.code === 'YB') || {}
    },

    //获取foot配置
    getFooterConfig(state){
      return state.globalConfig.find(item => item.code === 'DZZX') || {}
    },
    //获取logo
    getLogoConfig(state){
      return state.globalConfig.find(item => item.code === 'LOGO') || {}
    },
    //获取平台名称配置
    getPlatformName(state){
      return state.globalConfig.find(item => item.code === 'PTMC') || {}
    },
    //获取是否哀悼
    getCondolence(state){
      return state.globalConfig.find(item => item.code === 'condolence') || {}
    },
    //首页获取气泡数据
    getcpsl(state) {
      return state.globalConfig.find(item => item.code === 'cpsl') || {}
    },
    getsjsl(state) {
      return state.globalConfig.find(item => item.code === 'sjsl') || {}
    },
    getwxzy(state) {
      return state.globalConfig.find(item => item.code === 'wxzy') || {}
    }
  },
}
